import styled from 'styled-components'
import { Pill } from '@dsny/dsny-component-library'
import { releaseInfoMobileDownQuery } from '../../responsiveQueries'

export const ReleaseDetailsLayout = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 24px;
  width: 100%;
  min-width: 0;

  @media ${releaseInfoMobileDownQuery} {
    flex-direction: column;
    gap: 20px;
  }
`

export const ReleaseCoverArtSlot = styled.div`
  flex: 0 0 auto;

  @media ${releaseInfoMobileDownQuery} {
    width: 100%;
  }
`

export const ReleaseDetailsCol = styled.div`
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  flex-direction: column;
  gap: 12px;

  @media ${releaseInfoMobileDownQuery} {
    width: 100%;
    gap: 16px;
  }
`

export const ReleaseMetaRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  row-gap: 4px;
`

export const ReleaseMetaItem = styled.div`
  display: inline-flex;
  align-items: center;
`

export const ReleaseMetaSeparator = styled.span`
  margin: 0 8px;
  color: ${({ theme }) => theme.colors.neutralW60};
`

export const CanadianContentPill = styled(Pill)`
  width: fit-content;
  max-width: none;
  background-color: ${({ theme }) => theme.colors.neutralW30};
  color: ${({ theme }) => theme.colors.neutralW90};
`

export const ContainsAIPill = styled(Pill)`
  background-color: ${({ theme }) => theme.colors.neutralW30};
  color: ${({ theme }) => theme.colors.neutralW90};
  cursor: pointer;
`
